import WebComponent from "../../WebComponent";
import ZVVDto from "./ZVVDto";
import {html} from "@isceco/widget-library2/external/lit";
import '../../components/StaticDetailList/StaticDetailList'
import '@isceco/widget-library2/basic-elements/List/StaticList.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import DetailRow from "../../components/StaticDetailList/DetailRow";
import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import BerechtigungUtil from "../../services/BerechtigungUtil";

export default class ZVVStammdaten extends WebComponent {

  static get properties() {
    return {
      zvv: {type: ZVVDto}
    }
  }

  constructor() {
    super()
  }

  get translationFile() {
    return './views/ZVV/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('zvv.stammdaten.title')}">
        ${this._getButtons()}
      </isceco-title>
      <eko-static-detail-list id="zvv-stammdaten" .data="${this._getListData()}"></eko-static-detail-list>
    `
  }

  _getButtons() {
    if (new AuthorizationFilter().roles.GP_SUPERUSER &&
      new BerechtigungUtil().getActiveProfile().uuid === this.zvv.koordinierenderBenutzer.uuid) {
      return html`
        <div style="display: flex; justify-content: center; align-items: center; gap: var(--isceco-space-200)">
          <isceco-button id="edit-button"
                         size="small" icon="pencil" variant="primary"
                         text="${this.i18n.translate('zvv.stammdaten.edit')}"
          ></isceco-button>
          <isceco-button id="edit-button"
                         size="small" icon="trash" variant="danger"
                         text="${this.i18n.translate('zvv.stammdaten.aufloesen')}"
          ></isceco-button>
        </div>
      `
    }
    return html``
  }

  _getListData() {
    return [
      new DetailRow(this.i18n.translate('zvv.stammdaten.extId'), this.zvv.extId),
      new DetailRow(this.i18n.translate('zvv.stammdaten.name'), this.zvv.name),
      new DetailRow(this.i18n.translate('zvv.stammdaten.ki'), this.zvv.koordinierenderBenutzer.name),
      new DetailRow(this.i18n.translate('zvv.stammdaten.ki.adresse'), this.zvv.geschaeftspartner.adresse),
      new DetailRow(this.i18n.translate('zvv.stammdaten.verantworliche'), this.zvv.verantwortlicherBenutzer.name),
      new DetailRow(this.i18n.translate('zvv.stammdaten.verantwortliche.email'), this.zvv.verantwortlicherBenutzer.email),
      new DetailRow(this.i18n.translate('zvv.stammdaten.telefon'), this.zvv.telefon),
    ]
  }
}

customElements.define('eko-frontend-zvv-stammdaten', ZVVStammdaten)
